import React from 'react';
import {
  RetirementCalculatorField,
  SavingsProduct,
} from '../../tools/RetirementCalculator.const';
import { RetirementCalculatorOutcomeStepPropsModel } from '../../tools/RetirementCalculator.model';
import { RetirementCalculatorSummary } from '../RetirementCalculatorSummary/RetirementCalculatorSummary';
import { RetirementCalculatorOutcome } from '../RetirementCalculatorOutcome/RetirementCalculatorOutcome';
import { RetirementCalculatorLimits } from '../RetirementCalculatorLimits/RetirementCalculatorLimits';
import { RetirementCalculatorLayout } from '../RetirementCalculatorLayout/RetirementCalculatorLayout';

import useLayoutStyles from '../RetirementCalculatorLayout/RetirementCalculatorLayout.style';

export const RetirementCalculatorOutcomeStep: React.FC<RetirementCalculatorOutcomeStepPropsModel> = ({
  basicData,
  savings,
  settings,
  settingsOverrides,
  onSettingsOverridesChange,
  onEdit,
  projection,
  promotedProduct,
  payoutYears,
  monthlyInvestment,
  maxMonthlyInvestment,
  onMonthlyInvestmentChange,
  promoTitle,
  promoDescription,
  learnMoreLabel,
  learnMoreUrl,
  onDownloadSummary,
}) => {
  const c = useLayoutStyles({});

  return (
    <RetirementCalculatorLayout>
      <RetirementCalculatorSummary
        className={c.formColumn}
        basicData={basicData}
        savings={savings}
        settings={settings}
        settingsOverrides={settingsOverrides}
        onSettingsOverridesChange={onSettingsOverridesChange}
        onEdit={onEdit}
      />
      {promotedProduct ? (
        <RetirementCalculatorOutcome
          className={c.previewColumn}
          projection={projection}
          promotedProduct={promotedProduct}
          hasIke={!!savings?.[SavingsProduct.IKE]?.enabled}
          employmentType={basicData?.[RetirementCalculatorField.EMPLOYMENT_TYPE]}
          payoutYears={payoutYears}
          monthlyInvestment={monthlyInvestment}
          maxMonthlyInvestment={maxMonthlyInvestment}
          onMonthlyInvestmentChange={onMonthlyInvestmentChange}
          promoTitle={promoTitle}
          promoDescription={promoDescription}
          learnMoreLabel={learnMoreLabel}
          learnMoreUrl={learnMoreUrl}
          onDownloadSummary={onDownloadSummary}
        />
      ) : (
        <RetirementCalculatorLimits className={c.previewColumn} projection={projection} />
      )}
    </RetirementCalculatorLayout>
  );
};
